import { Button, Card, CardContent, CardHeader, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Pagination, Paper, Select, SelectChangeEvent, Stack, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useCallback, useEffect, useState,KeyboardEvent } from "react";
import { useNavigate } from "react-router-dom";
import { T_Inquery } from "../../common/model/InqueryModel";
import { useProgress } from "../../contexts/ProgressContextProvider";
import { T_Page } from "../../common/model/apiModel";
import apis from "../../common/apis";
import { T_Trouble } from "../../common/model/troubleModel";
import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import AttachFileIcon from '@mui/icons-material/AttachFile';  
import { T_File } from "../../common/model/fileModel";
import values from "../../common/values";
import { T_Code } from "../../common/model/codeModel";
import { Search, SearchIconWrapper, StyledInputBase, StyledTableCell } from '../../common/style/styles';
import SearchIcon from '@mui/icons-material/Search';
      


export default function TroubleList(){

    const nav = useNavigate();

    const pagesize = 10;
    const [page,setPage] = useState(1);
    const [list,setList] =  useState<T_Trouble[] | null>(null);
    const {showProgress,setShowProgress} = useProgress();
    const [pageInfo,setPageInfo] = useState<T_Page>()
    const {alert,setAlert} = useAlert();
    const [skeyword,setSkeyword]=useState("");
    
        
    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
      };

    const handleDataDel = async(item:T_Trouble)=>{

        setAlert({...alert,visible:true,msg:"정말로 삭제 하시겠습니까?",buttonList:[{text:"예",variant:"contained",onPress:async()=>{
            console.log("del request:",item)
                const result = await apis.trouble.troubleDelete(item);
                console.log("del result:",result)
                if(result.code=="1"){
                    setAlert(initialAlert);
                    setAlert({...alert,msg:"정상적으로 삭제되었습니다."})
                   getList();
                }else{
                    setAlert(initialAlert);
                    setAlert({...alert,msg:"삭제중 오류가 발생하였습니다다."})
                }
                
        }}
        ,{text:"아니요",variant:"outlined",onPress:()=>{
            setAlert({...alert,visible:false});

        }}
    ]})
    }  

  
 // 파일 메뉴 상태
  const [anchorElFile, setAnchorElFile] = useState<null | HTMLElement>(null);
  const [fileMenuRow, setFileMenuRow] = useState<number | null>(null);
  const handleFileIconClick = (e: React.MouseEvent<HTMLElement>, row: number) => {
    setAnchorElFile(e.currentTarget);
    setFileMenuRow(row);
  };
  const handleFileMenuClose = () => {
    setAnchorElFile(null);
    setFileMenuRow(null);
  };

  // 파일 다운로드
  const handleDownload = (file: T_File) => {
    const link = document.createElement('a');
    link.href = values.server.url+"/upload/"+ file.fileUrl;
   file.fileOrgNm &&  link.setAttribute('download', file.fileOrgNm);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    handleFileMenuClose();
  };


   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [menuRow, setMenuRow] = useState<number | null>(null)
    const open = Boolean(anchorEl);
    const handleClick = (e: React.MouseEvent<HTMLElement>, idx: number) => {
      setAnchorEl(e.currentTarget)
      setMenuRow(idx)
    }   
    const handleClose = () => {
        setAnchorEl(null);
        setMenuRow(null);
      }; 


  const [typeList,setTypeList] = useState<T_Code[]>();
  const [gubunList,setGubunList] = useState<T_Code[]>();
  const [selGubun,setSelGubun] = useState("all")
  const [selType,setSelType] = useState("all")

  const getTypeList = async()=>{
      const result = await apis.code.codeList({pCode:"type"})
      console.log(result)
      if(result.code=="1"){
         setTypeList(result.data.list);
//         setData({...data,type:result.data.list[0].code})
      }
   }   
   const getGubunList = async()=>{
      const result = await apis.code.codeList({pCode:"gubun"})
      console.log(result)
      if(result.code=="1"){
         setGubunList(result.data.list);
//         setData({...data,type:result.data.list[0].code})
      }
   }   


    const getList = useCallback(async () => {
        try {
          setShowProgress(true);
          const result = await apis.trouble.troubleList(
            {
              page:Number(page),
              pagesize:pagesize,
              type:selType,
              gubun:selGubun,
              skeyword:skeyword
            }
          );
          console.log("resut:",result)
            if(result.code=="1"){
            
                setList(result.data.list);
                setPageInfo(result.data);
                setShowProgress(false);
    
            }else{
                 
              setShowProgress(false);
            }
    
       
    
        } catch (err: any) {
          setShowProgress(false);
        }
      }, [page,selGubun,selType,skeyword]);

 
   function onKeyDown(e: KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
      if (e.key === 'Enter') {
        e.preventDefault(); // form 리프레시 방지
          getList()
      }
    }

      useEffect(() => {
          getList();
      }, [page,selGubun,selType]);   
   useEffect(()=>{
      getTypeList();
      getGubunList();
   },[])



    return(
      <>
      <Card sx={{width:'100%'}} >
        <CardHeader sx={{pr:5,pb:0,mb:0}} title="트러블 슈팅"  action={
          <Stack   direction="row"
                justifyContent="space-between"  // ← 여기만 바꿔주세요
                spacing={2}                     // 아이템 사이 약간의 간격
                sx={{ pt: 5, width: '100%' }}   // 전체 너비 확보
                >
                  <Search>
                      <SearchIconWrapper onClick={() => setPage(1)}>
                        <SearchIcon />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Search…"
                        inputProps={{ 'aria-label': 'search' }}
                        value={skeyword}
                        onChange={(e) => {
                          setSkeyword(e.target.value);
                        }
                      }
                        onKeyDown={onKeyDown}
                      />
                    </Search>   
          <Select
            value={selGubun}
            size="small"
            onChange={(event:SelectChangeEvent)=>{
              setSelGubun(event.target.value)
            }}
          >
            <MenuItem value="all">구분 전체</MenuItem>
            {
              gubunList?.map((item,idx)=>{
                  return(<MenuItem key={idx} value={item.name}>{item.name}</MenuItem>)
              })
            }
          </Select>
          <Select
            value={selType}
            size="small"
            onChange={(event:SelectChangeEvent)=>{
              setSelType(event.target.value)
            }}
          >
            <MenuItem value="all">항목 전체</MenuItem>
                        {
              typeList?.map((item,idx)=>{
                  return(<MenuItem  key={idx} value={item.name}>{item.name}</MenuItem>)
              })
            }
          </Select>

          <Button variant="outlined" onClick={()=>{
            nav("/trouble/insert")
          }}>
           등록
          </Button>
          </Stack>
        }
        />
        <CardContent>
        <TableContainer component={Paper}>
      <Table  aria-label="simple table">
        <TableHead>
          <TableRow>
            <StyledTableCell  sx={{width:100,textAlign:'center'}}>구분</StyledTableCell>
            <StyledTableCell align="left" sx={{width:'8%',textAlign:'center'}} >에러코드</StyledTableCell>
            <StyledTableCell align="left"  sx={{width:'10%',textAlign:'center'}}>항목</StyledTableCell>
            <StyledTableCell align="center"  sx={{width:'25%',textAlign:'center'}}>문의내용</StyledTableCell>
            <StyledTableCell align="center"  sx={{width:'25%',textAlign:'center'}}>처리방법</StyledTableCell>
            <StyledTableCell align="center"  sx={{width:'15%',textAlign:'center'}}>첨부파일</StyledTableCell>
            <StyledTableCell align="center"  sx={{textAlign:'center'}}>비고</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {list && list.map((item,idx) => (
            <TableRow
              key={idx}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } } }
            hover>
              <TableCell component="th" scope="row">
                {item.gubun}
              </TableCell>
              <TableCell align="left">{item.errcode=="null"?'':item.errcode}</TableCell>
              <TableCell align="left">{item.type}</TableCell>
              <TableCell align="left">  { item.contents && item.contents.length > 50
                                        ? `${item.contents.slice(0, 50)}...`
                                        : item.contents}
              </TableCell>
              <TableCell align="left"> { item.pmethod && item.pmethod.length > 50
                                        ? `${item.pmethod.slice(0, 50)}...`
                                        : item.pmethod}</TableCell>
             {/* 파일 셀 */}
                  <TableCell align="center">
                    {item.files && item.files.length > 0 ? (
                      <>
                        <IconButton
                          size="small"
                          onClick={(e) => handleFileIconClick(e, idx)}
                        >
                          <AttachFileIcon />
                        </IconButton>
                        <Menu
                          anchorEl={anchorElFile}
                          open={fileMenuRow === idx}
                          onClose={handleFileMenuClose}
                          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                        >
                          {item.files.map((file, idx2) => (
                            <MenuItem key={idx2} onClick={() => handleDownload(file)}>
                              <ListItemIcon>
                                <AttachFileIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>{file.fileOrgNm}</ListItemText>
                            </MenuItem>
                          ))}
                        </Menu>
                      </>
                    ) : (
                      '—'
                    )}
                  </TableCell>
              <TableCell align="center">{ <>
                    <IconButton
                      aria-label="menu"
                      onClick={(e) => handleClick(e, idx)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={menuRow === idx}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleClose()
                          nav("/trouble/edit",{state:{item:item}})  
                        }}
                      >
                        수정
                      </MenuItem>
                      <MenuItem
                        onClick={async() => {
                          handleClose()
                          handleDataDel(item)
                        }}
                      >
                        삭제
                      </MenuItem>
                    </Menu>
                  </>}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
        <Stack   direction="row"
        justifyContent="flex-end"
        alignItems="center" sx={{pt:5,justifyContent:'center',alignContent:'center',justifyItems:'center',alignItems:'ceter'}}>
        <Pagination count={pageInfo?.pages} showFirstButton showLastButton boundaryCount={2} onChange={handleChange}/>
        </Stack>
        </CardContent>
      </Card>
      </>
    )
}